<gpd-multi-step-form
  i18n-title="@@createNewProject"
  title="Create New Project"
  [steps]="steps"
  [finishText]="finishText"
  (onCancelClicked)="onCancelClicked()"
  (onFinishClicked)="onFinishClicked()"
  (onNextClicked)="onNextClicked($event)"
  [style.width.px]="800"
  [style.height.vh]="70">

  <ng-template #projectDataTemplate let-validationGroup="validationGroup">
    <app-project-data-step
      [projectData]="projectData"
      [persons]="persons"
      [companies]="companies"
      [areaTypes]="areaTypes"
      [validationGroup]="validationGroup"
      (onAreaTypeChange)="onAreaTypesChange()"
      (onStartDateChange)="onStartDateChange($event)"
      (projectDataChange)="onProjectDataChange($event)">
    </app-project-data-step>
  </ng-template>

  <ng-template #projectRolesTemplate let-validationGroup="validationGroup">
    <app-project-roles-step
      [projectData]="projectData"
      [departments]="departments"
      [users]="users"
      [validationGroup]="validationGroup"
      (projectDataChange)="onProjectDataChange($event)">
    </app-project-roles-step>
  </ng-template>

  <ng-template #projectScheduleTemplate let-validationGroup="validationGroup">
    <app-project-schedule-step
      #scheduleStep
      [projectData]="projectData"
      [schedule]="schedule"
      [validationGroup]="validationGroup"
      (projectDataChange)="onProjectDataChange($event)"
      (scheduleChange)="onScheduleChange($event)">
    </app-project-schedule-step>
  </ng-template>

  <ng-template #projectConnectionTemplate let-validationGroup="validationGroup">
    <app-project-connection-step
      [siteContracts]="siteContracts"
      [contractTypes]="contractTypes"
      [selectedContractIds]="selectedContractIds"
      (selectedContractIdsChange)="selectedContractIds = $event">
    </app-project-connection-step>
  </ng-template>

</gpd-multi-step-form>
